export interface FilterConfig {
  available: string[]; // List of filter keys to show
  options: {
    [key: string]: {
      type: "select" | "text" | "date" | "range";
      label: string;
      selectOptions?: { value: string; label: string }[];
    };
  };
}

export const filterConfigs = {
  projects: {
    available: [
      "growthStage",
      "productStage",
      "dateFrom",
      "dateTo",
    ] as string[],
    options: {
      growthStage: {
        type: "select",
        label: "Growth Stage",
        selectOptions: [
          { value: "Pre-seed", label: "Pre-seed" },
          { value: "Seed", label: "Seed" },
          { value: "Series A", label: "Series A" },
          { value: "Series B+", label: "Series B+" },
          { value: "Mature", label: "Mature" },
        ],
      },
      productStage: {
        type: "select",
        label: "Product Stage",
        selectOptions: [
          { value: "Idea/Concept", label: "Idea/Concept" },
          { value: "MVP", label: "MVP" },
          { value: "Beta", label: "Beta" },
          { value: "Launched", label: "Launched" },
          { value: "Scaling", label: "Scaling" },
        ],
      },
      dateFrom: {
        type: "date",
        label: "Date From",
      },
      dateTo: {
        type: "date",
        label: "Date To",
      },
    } as FilterConfig["options"],
  },
  icps: {
    // available: ["status", "sortBy", "dateFrom", "dateTo"] as string[],
    available: ["sortBy", "dateFrom", "dateTo"] as string[],
    options: {
      //   status: {
      //     type: "select",
      //     label: "Status",
      //     selectOptions: [
      //       { value: "all", label: "All" },
      //       { value: "draft", label: "Draft" },
      //       { value: "active", label: "Active" },
      //       { value: "archived", label: "Archived" },
      //     ],
      //   },
      sortBy: {
        type: "select",
        label: "Sort By",
        selectOptions: [
          { value: "createdAt", label: "Created Date" },
          { value: "updatedAt", label: "Updated Date" },
          { value: "name", label: "Name" },
        ],
      },
      dateFrom: {
        type: "date",
        label: "Date From",
      },
      dateTo: {
        type: "date",
        label: "Date To",
      },
    } as FilterConfig["options"],
  },
  strategies: {
    available: [
      //   "status",
      //   "platform",
      "sortBy",
      "dateFrom",
      "dateTo",
    ] as string[],
    options: {
      //   status: {
      //     type: "select",
      //     label: "Status",
      //     selectOptions: [
      //       { value: "all", label: "All" },
      //       { value: "draft", label: "Draft" },
      //       { value: "active", label: "Active" },
      //       { value: "archived", label: "Archived" },
      //     ],
      //   },
      //   platform: {
      //     type: "select",
      //     label: "Platform",
      //     selectOptions: [
      //       { value: "all", label: "All" },
      //       { value: "googleAds", label: "Google Ads" },
      //       { value: "facebookAds", label: "Facebook Ads" },
      //       { value: "linkedinAds", label: "LinkedIn Ads" },
      //       { value: "redditAds", label: "Reddit Ads" },
      //       { value: "snapchatAds", label: "Snapchat Ads" },
      //       { value: "tiktokAds", label: "TikTok Ads" },
      //     ],
      //   },
      sortBy: {
        type: "select",
        label: "Sort By",
        selectOptions: [
          { value: "createdAt", label: "Created Date" },
          { value: "updatedAt", label: "Updated Date" },
          { value: "name", label: "Name" },
        ],
      },
      dateFrom: {
        type: "date",
        label: "Date From",
      },
      dateTo: {
        type: "date",
        label: "Date To",
      },
    } as FilterConfig["options"],
  },
  insights: {
    available: ["sortBy", "dateFrom", "dateTo"] as string[],
    options: {
      sortBy: {
        type: "select",
        label: "Sort By",
        selectOptions: [
          { value: "createdAt", label: "Created Date" },
          { value: "updatedAt", label: "Updated Date" },
          { value: "name", label: "Name" },
        ],
      },
      dateFrom: {
        type: "date",
        label: "Date From",
      },
      dateTo: {
        type: "date",
        label: "Date To",
      },
    } as FilterConfig["options"],
  },
  competitiveAnalysis: {
    available: ["sortBy", "dateFrom", "dateTo"] as string[],
    options: {
      sortBy: {
        type: "select",
        label: "Sort By",
        selectOptions: [
          { value: "createdAt", label: "Created Date" },
          { value: "updatedAt", label: "Updated Date" },
          { value: "name", label: "Name" },
        ],
      },
      dateFrom: {
        type: "date",
        label: "Date From",
      },
      dateTo: {
        type: "date",
        label: "Date To",
      },
    } as FilterConfig["options"],
  },
} as const;
